import { Component, Input, OnInit, HostListener} from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { PosturalService } from '../../services/postural.service';
import { BikeService2 } from '../../services/bike2.service';
import { ServService } from '../../services/serv.service';
import { ServModel } from '../../models/serv.model';
import { OrderModel } from '../../models/order.model';
import { OrderService } from '../../services/order.service';

@Component({
    selector   : 'my-table',
    template: require('./table.component.html'),
    styles: [require('./table.component.scss')]
})

export class TableComponent implements OnInit {

    @Input('functionLoader') functionLoader: string;
    @Input('privateId') privateId: string;

    data = [];
    dragStatus:string = null;
    dragError:number = 0;
    dragSuccess:number = 0;
    table = this;
    elementSelected = null;

    listModal = {
        'delete': false,
        'deleteBike': false
    };

    constructor(public orderService:OrderService, public servService:ServService, public bikeService2:BikeService2, public customerService: CustomerService, private router: Router, public apiService: ApiService, public posturalService: PosturalService, public bikeService:BikeService2) {

    }

    ngOnInit(): void {
        if (this.functionLoader == 'getActivities'){
            this.customerService.getActivities(this.privateId);
            this.data = this.customerService.activities.data;
        } else {
            this.customerService[this.functionLoader](this.privateId, this.data);
        }
    }

    toDouble(number:number){
        if (number)
            return number.toFixed(2);
        return '';
    }

    serviceIdFormat(id:string){
        let id2 = id.split('-');
        return id2[1];
    }

    openBike(bike){
        this.bikeService2.current = bike;
        this.bikeService2.isOpen = true;
    }

    isService(d):boolean{
        return (d.type == 'Service' || d instanceof ServModel)
    }

    isOrder(d):boolean{
        return (d.type == 'Commande' || d instanceof OrderModel)
    }

    open(data){
        //open invoice
        if (data.type == 'Facture'){
            this.router.navigate(['/invoice', this.privateId, data.id]);
        }
        if (data.type == 'Quote'){
            this.router.navigate(['/quote', this.privateId, data.id]);
        }
        //open service
        if (data.type == 'Service' || data instanceof ServModel){
            let index = 0;
            for(let i = 0; i < this.data.length; i++){
                if (data == this.data[i]){
                    index = i;
                }
            }
            if (!(data instanceof ServModel)) {
                this.data[index] = ServModel.j2o(data, this.servService);
            }
            this.servService.current = this.data[index];
            this.servService.current.type = 'Service';
            this.bikeService.list = [];
            this.bikeService.getAll(this.servService.current.client.id);
        }
        //open order
        if (data.type == 'Commande' || data instanceof OrderModel){
            let index = 0;
            for(let i = 0; i < this.data.length; i++){
                if (data == this.data[i]){
                    index = i;
                }
            }
            if (!(data instanceof OrderModel)) {
                this.data[index] = OrderModel.j2o(data, this.orderService);
            }
            this.orderService.current = this.data[index];
            this.orderService.current.type = 'Commande';
        }
        //download doc
        if (data.type == 'Word' || data.type == 'Excel' || data.type == 'Pdf' || data.type == 'Image'){
            this.apiService.downloadFile(data.id);
        }
        //open Postit
        if (data.type == 'Postit'){
            this.router.navigate(['/postit']);
        }
        //download paper
        if (data.type == 'paper'){
            this.apiService.downloadLetter(data.idPdf);
        }
    }

    duplicateInvoice(data){
        this.router.navigate(['/invoice', this.privateId, data.id, '/duplicate']);
    };

    duplicateQuote(data){
        this.router.navigate(['/quote', this.privateId, data.id, '/duplicate']);
    };

    postitContentFormat(text){
        text = text.replace(/&nbsp;/g, ' ');
        return text.replace(/\[.{24}\]/g, '[CLIENT]');
    }

    getDate(dateString){
        if (dateString == null)
            return '-';
        let date = new Date(dateString);
        return ("0" + date.getDate()).slice(-2) + '.' + ("0" + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear();
    }

    invoicePdf(data){
        this.apiService.invoicePdf(data.id);
    }

    quotePdf(data){
        this.apiService.quotePdf(data.id);
    }

    deleteOpen(d){
        this.elementSelected = d;
        this.listModal.delete = true;
    }

    deleteBike(){
        this.bikeService2.del(this.listModal.deleteBike);
    }

    delete(){
        //delete doc
        if (this.elementSelected.type == 'Word' || this.elementSelected.type == 'Excel' || this.elementSelected.type == 'Pdf' || this.elementSelected.type == 'Image'){
            this.apiService.delete('file', {privateId:this.elementSelected.id}).subscribe((_res) => {
                this.loadData();
            }, (_err) => {
                this.apiService.error(_err);
            });
        }
    }

    dragLeave(event){
        this.dragStatus = null;
        event.preventDefault();
    }

    dragEnter(event){
        event.preventDefault();
        this.dragStatus = 'enter';
    }

    loadData(){
        this.customerService[this.functionLoader](this.privateId, this.data);
    }

    @HostListener('drop', ['$event'])
    onDrop(event) {
        event.preventDefault();
        this.dragError = 0;
        this.dragSuccess = 0;
        this.dragStatus = 'inProgress';
        let dt = event.dataTransfer;
        let length = dt.items.length;
        for (var i=0; i < dt.items.length; i++) {
            if (dt.items[i].kind == "file") {
                this.apiService.upload(this.privateId, dt.items[i].getAsFile()).subscribe((_res)=> {
                    this.dragSuccess++;
                    if (length == this.dragSuccess + this.dragError) {
                        this.dragStatus = null;
                        this.loadData();
                    }
                }, _err => {
                    this.dragError++;
                    if (length == this.dragSuccess + this.dragError) {
                        this.dragStatus = null;
                        this.loadData();
                    }
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/table/table.component.ts